const setHtmlHeaders = ({ title = '', description = '', keywords = '', image = '' }) => {
    document.title = title;
    document.querySelector('meta[name="description"]').setAttribute('content', description);
    document.querySelector('meta[name="keywords"]').setAttribute('content', keywords);

    document.querySelector('meta[name="og:title"]').setAttribute('content', title);
    document.querySelector('meta[name="og:description"]').setAttribute('content', description);
    document.querySelector('meta[name="og:image"]').setAttribute('content', image);
};

export default setHtmlHeaders;
